import { RootState } from "store";
export const activeDispensary = (state: RootState) =>
  state.cart.activeDispensary;
export const recPreviousResultData = (state: RootState) =>
  state.recs.recPreviousResultData;
